import React from 'react';
import ManageEntityList from './ManageEntityList';
import BidDetail from '../Editors/BidDetail';
import { Route, useHistory, useParams } from 'react-router-dom';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import { useAuth } from '../../Services/AuthContext';
import { useAlert } from '../../Services/AlertContext';

const CharterRequestBidHistory = ({ item, route, parentHeight }) => {
    const params = useParams();
    const alert = useAlert();
    const history = useHistory(); 
    const [auth] = useAuth(); 
    const onClickView= (row) =>{
        if (auth.role === "Supplier" && row.bidderId !== auth.supplierId) {
            alert({title: "Not Visible", body: "Sorry, but you can only view your own bid."});
        }
        else {
            history.push(route + '/' + row.id);
        }
    }
    const itemParam = params.clientAction === "Charters" ? (params.list === 'Client' ? 'messageId' : (params.list === 'Department' ? 'messageId' : params.list === 'Staff' ? 'messageId' : 'charterRequestId')) : (params.clientAction === 'Staff' ? 'charterRequestId' : (params.clientAction === 'Departments' ? params.departmentAction === 'Staff' ? 'bidId' : 'charterRequestId' : (params.departmentAction === 'Charters' ? 'charterRequestId' : 'bidId')));
    const ent = auth.canViewSupplierInfo ? entities.supplierBidSupplierVisibile: entities.supplierBid
    const entity = {...ent , itemParam };
    const actions = [{ name: 'View', action: onClickView },]
    return <React.Fragment> <ManageEntityList item={item} route={route} parentHeight={parentHeight} entity={entity} headerHeight={0} actions={actions} />
        <Route path={route + '/:bidId'} render={({ match }) => {
            return <ClientModal route={route} entity={entity} itemParam='bidId' >  <BidDetail route={route+"/" + match.params.bidId} edit={true} noEdit={true} placeBid supplierId={match.params.bidId}   /></ClientModal>
        }} />
    </React.Fragment>
}
export default CharterRequestBidHistory;
